import React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { getCompanyBaseBreadcrumbs } from "src/Pages/Company/routerHelper";
import { TYPE_LISTING } from "src/utils/browsingHistory";
import useIsAhr from "src/utils/hooks/useIsAhr";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import __ from "src/utils/Translations";
import Listing from "./Listing";

export default function BenefitsPending() {
  const companyId = useCompanyId();
  const companyName = useCompanyName();

  const isAhr = useIsAhr();

  return (
    <>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <PageTitle
          heading={`${__(
            "Benefity oczekujące dla firmy"
          )} ${companyName} (ID: ${companyId})`}
          breadcrumbsHeading={__("Benefity oczekujące")}
          breadcrumbs={
            isAhr ? [] : [...getCompanyBaseBreadcrumbs(companyId, companyName)]
          }
          pushToHistory
          historyElementType={TYPE_LISTING}
        />
        <Listing />
      </CSSTransitionGroup>
    </>
  );
}
